import React from "react";
import { Eye } from "lucide-react";

export default function ButtonExibir({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 bg-[#1e7f14] text-white px-4 py-2 shadow-md transition-transform duration-200 hover:scale-105"
      style={{
        borderRadius: "0px",
        fontFamily: "Comfortaa, cursive",
        fontWeight: 600,
        fontSize: "15px",
      }}
    >
      <Eye size={18} />
      Exibir
    </button>
  );
}
